import { FilterSeason } from '@enums/Filter';
import { CatalogListLink } from '@app/enums/Home';

export const handlerSortSeason = (season: FilterSeason, regionPartner: boolean, catalogList: CatalogListLink[]): CatalogListLink[] => {
  const list = regionPartner ? catalogList.filter(x => x.title !== 'Моторные масла' && x.title !== 'Аккумуляторы') : catalogList;

  if (season === FilterSeason.WINTER) {
    return list.sort((a, b) => {
      if (a.title === 'Зимние шины' && b.title !== 'Зимние шины') {
        return -1;
      } else if (b.title === 'Зимние шины' && a.title !== 'Зимние шины') {
        return 1;
      }
      return 0;
    });
  }
  return list;
};
